import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "money_right",
  "use": "money_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"money_right\"><defs><style></style></defs><path d=\"M384 850.432c-15.36 15.36-38.912 15.36-54.272 0s-15.36-34.816-4.096-50.688l4.096-4.096L613.376 512l-284.16-283.136c-15.36-15.36-15.36-34.816-4.096-50.688l4.096-4.096c15.36-15.36 34.816-15.36 50.688-4.096L384 174.08l310.784 310.784c15.36 15.36 15.36 34.816 4.096 50.688l-4.096 4.096L384 850.432z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol